import Box from '@mui/material/Box';
import simplifiLogoTextDark from 'assets/logos/Quicken_Logo_static.gif';
import React from 'react';

// This is displayed before we have a redux context, which is required for our styling library. We use inline styles instead.
const PersistLoading = () => (
  <Box
    style={{
      height: '100vh',
      width: '100vw',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <img alt='loading...' src={simplifiLogoTextDark} height={48} data-testid='loading-image' />
  </Box>
);

export default PersistLoading;
